import { BarChart3, FileText, FolderKanban, Network, Users, Wallet, type LucideIcon } from 'lucide-react'
import { createElement } from 'react'
import { NAV_ICON_FALLBACK } from '@/components/layout/nav'

const ICONS: Record<string, LucideIcon> = {
  personnel: Users,
  documents: FileText,
  departments: Network,
  projects: FolderKanban,
  finance: Wallet,
  reports: BarChart3,
}

export function ModuleIcon({ module, className }: { module: string; className?: string }) {
  return createElement(ICONS[module] ?? NAV_ICON_FALLBACK, { className, 'aria-hidden': true })
}
